import React from "react";

export default function SQL_Avg() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Avg</h1>
      <p>This is the SQL_Avg component generated from the SQL JSON.</p>
    </div>
  );
}
